// extracted by mini-css-extract-plugin
export default {"giftformContainer":"giftformContainer__376qp","inputField":"inputField__2JVny","label":"label__3CVEG","requiredSign":"requiredSign__3L3b1","input":"input__3LAGI","switchInput":"switchInput__bJFB-","switch":"switch__1cFBQ","slider":"slider__x45tS","round":"round__1M61T","beneficiaryMessage":"beneficiaryMessage__1Lohn","errorMessage":"errorMessage__2g_l9"};
    if(module.hot) {
      // 1778491687948
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  